(function(){
  if(!/\/cart/.test(location.pathname)) return;
  if(sessionStorage.getItem('sk_return_after_atc')) return;

  function tarifa(base, qty){
    var f = qty >= 501 ? 0.80 : qty >= 201 ? 0.90 : 1;
    return Math.round(base * f) / 100;   // base en céntimos -> € con 2 decimales
  }

  function pintar(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(cart){
        (cart.items||[]).forEach(function(it,idx){
          if(document.querySelector('.sk-desglose-'+idx)) return;
          var fila = document.querySelectorAll('.cart__item, .cart-item, [class*="cart__row"]')[idx];
          if(!fila) return;
          var ud    = tarifa(it.price, it.quantity);
          var total = ud * it.quantity;
          var f = function(n){return n.toLocaleString('es-ES',{minimumFractionDigits:2});};
          var el = document.createElement('div');
          el.className = 'sk-desglose sk-desglose-'+idx;
          el.style.cssText='margin-top:8px;font-family:sans-serif;font-size:13px;line-height:1.7;color:#5a5750';
          el.innerHTML =
            'Precio unitario: <strong style="color:#004437">'+f(ud)+' €</strong><br>'+
            'Cantidad: <strong style="color:#004437">'+it.quantity+' uds</strong><br>'+
            'Total: <strong style="color:#004437;font-size:15px">'+f(total)+' €</strong>';
          fila.appendChild(el);
        });
      }).catch(function(){});
  }
  document.addEventListener('DOMContentLoaded',pintar);
  [900,2200].forEach(function(ms){setTimeout(pintar,ms);});
})();
